import "./UsedMechanicalBulls.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Catalog from "./sections/Catalog";
import BuyingUsed from "./sections/BuyingUsed";
import BuyerGuide from "./sections/BuyerGuide";
import EquipmentInclusions from "./sections/EquipmentInclusions";
import Usedbullpricing from "./sections/Usedbullpricing";
import Comparison from "./sections/Comparison";
import Advisory from "./sections/Advisory";
import Planning from "./sections/Planning";
import InflatableInspection from "./sections/InflatableInspection";
import ReplacementParts from "./sections/ReplacementParts";
import BullShipping from "./sections/BullShipping";
import UsedFaq from "./sections/UsedFaq";
import Enquiry from "./sections/Enquiry";
import Footer from "@/reusable_sections/Footer";
export default function UsedMechanicalBullsPage() {
  return <div>
      <Header />
      <Hero />
      <Catalog />
      <BuyingUsed />
      <BuyerGuide />
      <EquipmentInclusions />
      <Usedbullpricing />
      <Comparison />
      <Advisory />
      <Planning />
      <InflatableInspection />
      <ReplacementParts />
      <BullShipping />
      <UsedFaq />
      <Enquiry />
      <Footer />
    </div>;
}